import { executeQuerySync } from './AppSyncPlusAPIs';

const getBaseEmployeeQueryExpressions = () => {
  return [
    {
      "term": {
        "attribute": "basicInfo.jobStatus",
        "value": "A"
      }
    }
  ];
};

const buildEmployeeSearchQuery = (fragment, size, costCenters) => {
  const body = {
    "query": {
      "occurrence": "MUST",
      "expressions": getBaseEmployeeQueryExpressions()
    },
    "size": size,
    "sortBy": "WEIGHT_THEN_LOGIN"
  };

  if (costCenters) {
    body.query.expressions.push({
      "terms": {
        "attribute": "basicInfo.costCenterId",
        "value": costCenters
      }
    });
  }

  body.query.expressions.push({
    "wildcard": {
      "attribute": "basicInfo.login",
      "value": fragment.length > 0 ? `${fragment}*` : "*"
    }
  });

  return body;
};

export const getSuggestedLoginsV2 = async (fragment = "a", size = 10, costCenters, onSuccess, onFailure) => {
  try {
    const body = buildEmployeeSearchQuery(fragment, size, costCenters);

    let qry = `query MyQuery {
    searchEmployees(input: ${JSON.stringify(JSON.stringify(body))})
  }`
    const result = await executeQuerySync(qry, onSuccess, onFailure);
    const data = JSON.parse(result.data.searchEmployees);
    return data.records.map(record => record.basicInfo.login).sort();
  } catch (error) {
    console.error('Error fetching logins:', error);
    return [];
  }
};

const buildDirectReportsSearchQuery = (managerLogin, size, costCenters) => {
  const body = {
    "query": {
      "occurrence": "MUST",
      "expressions": getBaseEmployeeQueryExpressions()
    },
    "size": size,
    "sortBy": "WEIGHT_THEN_LOGIN"
  };

  if (costCenters) {
    body.query.expressions.push({
      "terms": {
        "attribute": "basicInfo.costCenterId",
        "value": costCenters
      }
    });
  }

  body.query.expressions.push({
    "term": {
      "attribute": "basicInfo.managerLogin",
      "value": managerLogin
    }
  });

  return body;
};

export const getDirectReportsByManagerLogin = async (managerLogin, size = 100, costCenters, onSuccess, onFailure) => {
  try {
    if (!managerLogin) {
      console.error('Manager login is required');
      return [];
    }

    const body = buildDirectReportsSearchQuery(managerLogin, size, costCenters);

    let qry = `query MyQuery {
    searchEmployees(input: ${JSON.stringify(JSON.stringify(body))})
  }`

    const result = await executeQuerySync(qry, onSuccess, onFailure);
    const data = JSON.parse(result.data.searchEmployees);

    return data.records.map(record => record.basicInfo.login).sort();
  } catch (error) {
    console.error('Error fetching direct reports:', error);
    if (onFailure) {
      onFailure(error);
    }
    return [];
  }
};

const buildEmployeeSearchQueryByLogins = (logins, size) => {
  const body = {
    "query": {
      "occurrence": "MUST",
      "expressions": []
    },
    "size": size,
    "sortBy": "WEIGHT_THEN_LOGIN"
  };

  if (logins && logins.length > 0) {
    body.query.expressions.push({
      "terms": {
        "attribute": "basicInfo.login",
        "value": logins
      }
    });
  }

  return body;
};

export const getEmployeesByLoginList = async (logins, size = 100, costCenters, onSuccess, onFailure) => {
  try {
    if (!logins || logins.length === 0) {
      return [];
    }

    const body = buildEmployeeSearchQueryByLogins(logins, size, costCenters);

    let qry = `query MyQuery {
    searchEmployees(input: ${JSON.stringify(JSON.stringify(body))})
  }`
    const result = await executeQuerySync(qry, onSuccess, onFailure);
    const data = JSON.parse(result.data.searchEmployees);
    return data.records || [];
  } catch (error) {
    console.error('Error fetching employees by login list:', error);
    if (onFailure) {
      onFailure(error);
    }
    return [];
  }
};
